export default __webpack_public_path__ + "static/media/LargeSBCTAcceptableMovementEdited.1cbc634c.mp4";